import { keyframes as e, styled as t } from "styled-components";
import { ILL_EASING as n, ILL_PAGE_TEXT as r } from "@maat/assets";
//#region src/components/EmptyState/PageEmptyState.styled.ts
var i = e`
    from { opacity: 0; transform: translateY(8px); }
    to { opacity: 1; transform: none; }
`, a = t.div`
    display: flex;
    flex-direction: column;
    align-items: ${({ $align: e }) => e === "center" ? "center" : "flex-start"};
    text-align: ${({ $align: e }) => e === "center" ? "center" : "left"};
    padding: ${({ theme: e }) => e.spacing(1)} ${({ theme: e }) => e.spacing(3)};
    ${({ $align: e }) => e === "center" && "margin: 0 auto;"}
    max-width: 460px;
`, o = t.div`
    display: flex;
    flex-direction: column;
    align-items: ${({ $align: e }) => e === "center" ? "center" : "flex-start"};

    /* The per-slot delay is set inline, not by nth-child: a family with no body
       line would otherwise hand the button the body's beat. */
    &.pl > * {
        animation: ${i} ${r.dur}ms cubic-bezier(${n.glide.join(",")}) both;
    }

    @media (prefers-reduced-motion: reduce) {
        & > * {
            animation: none !important;
        }
    }
`, s = t.div`
    margin-top: 18px;
`, c = t.div`
    margin-top: 10px;
    max-width: 372px;
    text-wrap: pretty;
`, l = t.div`
    margin-top: 24px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: ${({ $align: e }) => e === "center" ? "center" : "flex-start"};
    gap: ${({ theme: e }) => e.spacing(1.5)};
`;
//#endregion
export { o as CopyBlock, l as PageActionSlot, c as PageBodySlot, a as PageContainer, s as PageTitleSlot };
